// extracted by mini-css-extract-plugin
export default {"bringgReactTable":"exclusion-window-table_bringgReactTable__dE0FA","breakWordCell":"exclusion-window-table_breakWordCell__iZ3wq"};